module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fixedholder-gb', [_c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block] + '-scrollContainer'
  }, [_c('form', {
    class: [_vm.block + '-form'],
    attrs: {
      "id": "form",
      "method": "post",
      "action": "",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v("\n          " + _vm._s(_vm.data.titleText) + " "), _c('div', {
    class: [_vm.block + '-contact']
  }, [_c('a', {
    staticClass: "email",
    staticStyle: {
      "text-decoration": "underline",
      "color": "#0048FF"
    },
    attrs: {
      "href": "mailto:integration@spotin.com"
    }
  }, [_vm._v("integration@spotin.com")])])]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-divider']
  }), _vm._v(" "), _c('div', {
    class: ( _obj = {
      'bm-bottomMargin': true
    }, _obj[_vm.block + '-header2'] = true, _obj )
  }, [_vm._v(_vm._s(_vm.data.businessHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-blankDivider']
  }), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input'],
    attrs: {
      "label": _vm.data.companyNameLabel,
      "invalid": _vm.invalidInputs.companyName,
      "text": _vm.form.companyName
    },
    on: {
      "textChanged": function($event) {
        _vm.form.companyName = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header3']
  }, [_vm._v(_vm._s(_vm.data.businessContactHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.businessText))]), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input m-single'],
    attrs: {
      "label": _vm.data.nameLabel,
      "invalid": _vm.invalidInputs.businessContactName,
      "text": _vm.form.businessContactName
    },
    on: {
      "textChanged": function($event) {
        _vm.form.businessContactName = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-columns']
  }, [_c('input-form-block', {
    class: [_vm.block + '-input'],
    attrs: {
      "label": _vm.data.emailLabel,
      "invalid": _vm.invalidInputs.businessContactEmail,
      "text": _vm.form.businessContactEmail
    },
    on: {
      "textChanged": function($event) {
        _vm.form.businessContactEmail = $event
      }
    }
  }), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input'],
    attrs: {
      "label": _vm.data.phoneLabel,
      "invalid": _vm.invalidInputs.businessContactPhone,
      "text": _vm.form.businessContactPhone
    },
    on: {
      "textChanged": function($event) {
        _vm.form.businessContactPhone = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.block + '-divider']
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header2']
  }, [_vm._v(_vm._s(_vm.data.accountingHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.accountingText))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-columns']
  }, [_c('input-form-block', {
    class: [_vm.block + '-input m-single'],
    attrs: {
      "label": _vm.data.bankAccountLabel,
      "invalid": _vm.invalidInputs.bankAccount,
      "text": _vm.form.bankAccount
    },
    on: {
      "textChanged": function($event) {
        _vm.form.bankAccount = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text m-caption']
  }, [_vm._v(_vm._s(_vm.data.bankAccountText))])], 1), _vm._v(" "), _c('div', {
    class: [_vm.block + '-columns']
  }, [_c('input-form-block', {
    class: [_vm.block + '-input m-single'],
    attrs: {
      "label": _vm.data.emailLabel,
      "invalid": _vm.invalidInputs.accountingEmail,
      "text": _vm.form.accountingEmail
    },
    on: {
      "textChanged": function($event) {
        _vm.form.accountingEmail = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text m-caption']
  }, [_vm._v(_vm._s(_vm.data.accountingEmailText))])], 1), _vm._v(" "), _c('div', {
    class: [_vm.block + '-divider']
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header2']
  }, [_vm._v(_vm._s(_vm.data.technicalHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header3']
  }, [_vm._v(_vm._s(_vm.data.technicalContactHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.technicalContactText))]), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input m-single'],
    attrs: {
      "label": _vm.data.nameLabel,
      "invalid": _vm.invalidInputs.technicalContactName,
      "text": _vm.form.technicalContactName
    },
    on: {
      "textChanged": function($event) {
        _vm.form.technicalContactName = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-columns']
  }, [_c('input-form-block', {
    class: [_vm.block + '-input'],
    attrs: {
      "label": _vm.data.emailLabel,
      "invalid": _vm.invalidInputs.technicalContactEmail,
      "text": _vm.form.technicalContactEmail
    },
    on: {
      "textChanged": function($event) {
        _vm.form.technicalContactEmail = $event
      }
    }
  }), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input'],
    attrs: {
      "label": _vm.data.phoneLabel,
      "invalid": _vm.invalidInputs.technicalContactPhone,
      "text": _vm.form.technicalContactPhone
    },
    on: {
      "textChanged": function($event) {
        _vm.form.technicalContactPhone = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header2']
  }, [_vm._v(_vm._s(_vm.data.platformHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.platformText))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-columns']
  }, [_c('DropDown', {
    class: [_vm.block + '-input'],
    attrs: {
      "invalid": _vm.invalidInputs.platform,
      "data": _vm.platforms
    },
    on: {
      "dropDownSelect": _vm.selectPlatform
    }
  }), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input'],
    attrs: {
      "label": _vm.data.otherPlatformLabel,
      "invalid": _vm.invalidInputs.otherPlatform,
      "text": _vm.form.otherPlatform,
      "disabled": _vm.disableOtherPlatform
    },
    on: {
      "textChanged": function($event) {
        _vm.form.otherPlatform = $event
      }
    }
  })], 1), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input m-single'],
    attrs: {
      "label": _vm.data.platformVersionLabel,
      "invalid": _vm.invalidInputs.platformVersion,
      "text": _vm.form.platformVersion
    },
    on: {
      "textChanged": function($event) {
        _vm.form.platformVersion = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.otherDetailsText))]), _vm._v(" "), _c('textarea-block', {
    attrs: {
      "label": _vm.data.additionalDetailsLabel,
      "text": _vm.form.additionalDetails
    },
    on: {
      "textChanged": function($event) {
        _vm.form.additionalDetails = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-divider']
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header2']
  }, [_vm._v(_vm._s(_vm.data.mailOrderHeader))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.mailOrderText))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.data.mailOrderUseCase1))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.mailOrderUseCase2))])]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.mailOrderConfirmationText))]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-columns']
  }, [_c('label', {
    class: [_vm.block + '-radioLabel'],
    attrs: {
      "for": "mailOrderConfirm"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "mailOrderSelection",
      "id": "mailOrderConfirm",
      "value": "Use mailorder"
    },
    on: {
      "change": _vm.mailOrderSelection
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.block + '-radio', {
      'm-invalid': _vm.invalidInputs.useMailOrder
    }]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.mailOrderConfirm))])]), _vm._v(" "), _c('label', {
    class: [_vm.block + '-radioLabel'],
    attrs: {
      "for": "mailOrderDecline"
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "mailOrderSelection",
      "id": "mailOrderDecline",
      "value": "Do NOT use mailorder"
    },
    on: {
      "change": _vm.mailOrderSelection
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.block + '-radio', {
      'm-invalid': _vm.invalidInputs.useMailOrder
    }]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data.mailOrderDecline))])])]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.mailOrderEmailText))]), _vm._v(" "), _c('input-form-block', {
    class: [_vm.block + '-input m-single'],
    attrs: {
      "label": _vm.data.emailLabel,
      "invalid": _vm.invalidInputs.mailOrderEmail,
      "text": _vm.form.mailOrderEmail,
      "disabled": _vm.disableOrderEmail
    },
    on: {
      "textChanged": function($event) {
        _vm.form.mailOrderEmail = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-divider']
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-header1']
  }, [_vm._v("Logo")]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-text']
  }, [_vm._v(_vm._s(_vm.data.logoText))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.data.logoRequirement1))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.logoRequirement2))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.logoRequirement3))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.logoRequirement4) + "\n            "), _c('div', {
    class: [_vm.block + '-contact']
  }, [_c('a', {
    staticClass: "email",
    staticStyle: {
      "text-decoration": "underline",
      "color": "#0048FF"
    },
    attrs: {
      "href": "mailto:integration@spotin.com"
    }
  }, [_vm._v("integration@spotin.com")])])])]), _vm._v(" "), _c('label', {
    class: [_vm.block + '-selectFileLabel', {
      'm-invalid': _vm.invalidInputs.logoFiles
    }],
    attrs: {
      "for": "logoFiles"
    }
  }, [_c('input', {
    class: [_vm.block + '-selectFile'],
    attrs: {
      "name": "logoFiles",
      "id": "logoFiles",
      "type": "file",
      "data-multiple-caption": "{count} files selected",
      "multiple": ""
    },
    on: {
      "change": _vm.setFiles
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-uploadIcon']
  }, [(_vm.form.logoFiles.length <= 0) ? _c('icon-gb', {
    attrs: {
      "name": "spotin-com-upload",
      "size": "largest",
      "color": "#0046FF",
      "notextshadow": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.logoFiles.length > 0) ? _c('icon-gb', {
    attrs: {
      "name": "spotin-com-checkmarkWide",
      "size": "largest",
      "color": "#0046FF",
      "notextshadow": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.form.logoFiles.length <= 0) ? _c('div', [_vm._v("Choose file(s) or drop here")]) : _vm._e(), _vm._v(" "), (_vm.form.logoFiles.length > 0) ? _c('div', {
    class: [_vm.block + '-files']
  }, [_vm._v(_vm._s(_vm.form.logoFiles.length) + " file(s) chosen")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-divider']
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "invalidTransition"
    }
  }, [(_vm.showInvalidNotification) ? _c('div', {
    class: [_vm.block + '-invalidNotification']
  }, [_vm._v("Please correct the highlighted fields and send again")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.block + '-button']
  }, [_c('button-block', {
    class: {
      'bm-black': true
    },
    attrs: {
      "text": _vm.data.buttonText
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendMessage($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "successTransition"
    }
  }, [(_vm.success) ? _c('div', {
    class: [_vm.block + '-success']
  }, [_c('div', {
    class: [_vm.block + '-successText']
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.sentHtml)
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-okButton'],
    on: {
      "click": function($event) {
        _vm.success = false
      }
    }
  }, [_vm._v("OK")])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "successTransition"
    }
  }, [(_vm.errorModal) ? _c('div', {
    class: [_vm.block + '-success']
  }, [_c('div', {
    class: [_vm.block + '-successText']
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorModalHtml)
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-okButton'],
    on: {
      "click": function($event) {
        _vm.errorModal = false
      }
    }
  }, [_vm._v("OK")])])]) : _vm._e()])], 1)])
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9b00f8","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/IntegrationForm.vue
// module id = 501
// module chunks = 0